import { createSelector } from 'reselect';
export var getOrganizations = function getOrganizations(state) {
  return state.organizations;
};
export var getOrganizationsIds = function getOrganizationsIds(state) {
  return state.organizations.ids;
};
export var getOrganization = function getOrganization(state) {
  return state.organizations.organization;
};
export var getOrganizationsList = function getOrganizationsList(state) {
  return Object.values(state.organizations.entities);
};
export var getOrganizationsIsFetching = createSelector(getOrganizations, function (organizations) {
  return organizations == null ? void 0 : organizations.isFetching;
});
export var getOrganizationsIsLoaded = createSelector(getOrganizations, function (organizations) {
  return organizations == null ? void 0 : organizations.isLoaded;
});
export var getOrganizationsIsRequestFailed = createSelector(getOrganizations, function (organizations) {
  return organizations == null ? void 0 : organizations.isRequestFailed;
});
export var makeGetOrganization = function makeGetOrganization() {
  return createSelector(getOrganization, function (state, props) {
    return props.params;
  }, function (organization, _ref) {
    var organizationSlug = _ref.organizationSlug;
    return !!organization && organization[organizationSlug] || {};
  });
};
export var getOrganizationIsFetching = createSelector(makeGetOrganization(), function (organization) {
  return organization == null ? void 0 : organization.isFetching;
});
export var getOrganizationIsLoaded = createSelector(makeGetOrganization(), function (organization) {
  return organization == null ? void 0 : organization.isLoaded;
});
export var getOrganizationIsRequestFailed = createSelector(makeGetOrganization(), function (organization) {
  return organization == null ? void 0 : organization.isRequestFailed;
});